import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React from 'react';
const TableFoot = ({ columnDescriptor, className, children, ...other })=>/*#__PURE__*/ React.createElement("tfoot", {
        className: cx('Table-footer', className),
        ...other
    }, children);
TableFoot.propTypes = {
    /**
	 * Children will be rendered within the `TableFoot`.
	 */ children: PropTypes.node,
    /**
	 * Custom `className` for the root.
	 */ className: PropTypes.string,
    /**
	 * Descriptor of all columns (generated from header) which is added to the component on TableBody level.
	 */ columnDescriptor: PropTypes.object
};
TableFoot.displayName = 'TableFoot';
export default TableFoot;
